import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  informational: defineAsyncComponent(() => import("/vercel/path0/layouts/informational.vue").then(m => m.default || m))
}